import React, { useState } from 'react';
import { toast } from 'react-toastify';
import { strings } from '/imports/strings';
import { projectManagementRicImport, projectManagementWipeRicProjects } from '/imports/api/projectManagement';
import { toastOnError } from '/imports/ui/utils';
import { DevToolSection } from '/imports/ui/DevToolSection';
import { FileInput } from '/imports/ui/FileInput';
import { Loading } from '/imports/ui/Loading';
import { Button } from '/imports/ui/Button';
import { ConfirmModal } from '/imports/ui/ConfirmModal';
import { maxSpreadsheetUploadBytes } from '/imports/api/files';

/** Dev tool: wipe + re-import the RIC portfolio-tracker xlsx to seed the Project Management module. */
export const DevToolRicImport = () => {
  const [loading, setLoading] = useState(false);
  const [wiping, setWiping] = useState(false);
  const [confirmWipe, setConfirmWipe] = useState(false);
  const [result, setResult] = useState('');
  const busy = loading || wiping;
  const run = toastOnError(async (file: any) => {
    if (!file || busy) return;  // ignore a second file dropped while an import/wipe is in flight
    setLoading(true);
    setResult('');
    try {
      const res = await projectManagementRicImport.call({ file });
      setResult(JSON.stringify(res, null, 2));
      toast.success(strings.RicTrackerImported(res.rows, res.created, res.updated, res.skipped));
    }
    finally {
      setLoading(false);
    }
  });
  const wipe = toastOnError(async (password: string) => {
    setWiping(true);
    setResult('');
    try {
      const res = await projectManagementWipeRicProjects.call({ password });
      setResult(JSON.stringify(res, null, 2));
      toast.success(strings.RicProjectsWiped(res.projects, res.childRecords));
      setConfirmWipe(false);
    }
    finally {
      setWiping(false);
    }
  });
  return (
    <DevToolSection title={strings.RicTrackerImport()} description={strings.RicTrackerImportHelp()}>
      <FileInput placeholder={loading ? strings.Importing() : strings.UploadRicTracker()} maxSize={maxSpreadsheetUploadBytes} onChange={(file) => run(file)} />
      <div style={{ marginTop: '0.75rem' }}>
        <Button className="secondary" disabled={busy} onClick={() => setConfirmWipe(true)}>{wiping ? strings.Wiping() : strings.WipeRicProjects()}</Button>
      </div>
      {busy && <Loading caption={wiping ? strings.WipingRicProjects() : strings.ImportingRicTracker()} />}
      {!busy && result && <pre>{result}</pre> || null}
      {
        confirmWipe &&
        <ConfirmModal
          title={strings.WipeRicProjectsConfirm()}
          body={strings.WipeRicProjectsBody()}
          confirmText={strings.Wipe()}
          requirePassword
          onConfirm={(password) => wipe(password || '')}
          onClose={() => setConfirmWipe(false)}
        />
      }
    </DevToolSection>
  );
};
